module.exports = __webpack_public_path__ + "img/login_Ubg.0bc78e39.png";